import React from 'react';
import { IconArrowRight, IconArrowLeft } from '../../ui-kit/icons';
import { Badge } from '../../ui-kit';

export const allTypeIds = [
  'duty_exchange_outgoing',
  'duty_exchange_incoming',
  'absence_request',
  'duty_request',
  'extra_work_request'
];

// machine readable designator for the transaction type. This is used for e.g.
// filtering in tables
export const dutyTransactionTypeId = (transaction, userId) => {
  const { type, user_id } = transaction;
  if (type === 'duty_exchange') {
    const direction = String(user_id) === String(userId) ? 'outgoing' : 'incoming';
    return `${type}_${direction}`;
  } else {
    return type;
  }
};

const styleClasses = {
  duty_exchange_outgoing: 'success',
  duty_exchange_incoming: 'primary',
  absence_request: 'warning',
  duty_request: 'info',
  extra_work_request: 'secondary'
};

const directionArrow = {
  duty_exchange_outgoing: IconArrowRight,
  duty_exchange_incoming: IconArrowLeft
};

// translate to a human readable name for the type of duty transaction
const i18nKeys = {
  duty_exchange_outgoing: 'duty_exchange',
  duty_exchange_incoming: 'duty_exchange',
  absence_request: 'absence_request',
  duty_request: 'duty_request',
  extra_work_request: 'extra_work_request'
};

// internal function for rendering the actual label
const indicator = typeId => {
  const translation = I18n.t(`activerecord.models.schedule/exchanges/${i18nKeys[typeId]}.one`);
  const Icon = directionArrow[typeId];
  const directionIcon = Icon && <Icon />;

  return (
    <Badge variant={styleClasses[typeId]}>
      {translation} {directionIcon}
    </Badge>
  );
};

// Renders a clean indicator for the type of duty transaction as a colored
// bootstrap label. In case of duty exchanges, it also shows the type of the
// exchange with an arrow: incoming (left) or outgoing (right)
//
// Can be called using transaction and userId, or only typeId (e.g. for
// generating all type filtering options)
const DutyTransactionTypeIndicator = ({ transaction, userId, typeId }) => {
  if (!typeId) {
    typeId = dutyTransactionTypeId(transaction, userId);
  }
  return indicator(typeId);
};

export default DutyTransactionTypeIndicator;
